export default "__VITE_ASSET__yleI4N9w__"